<template>
  <div @click="navigate($event)" class="px-4  cursor-pointer">
    <div class="rounded overflow-hidden bg-white shadow-lg">
      <div class="px-6 py-4">
        <div class="program-main mb-2 tenant-main-color">
          {{ exercise.title }}
        </div>
        <p class="program-content text-gray-700 mb-4 text-base">
          {{ exercise.requirements }}
        </p>
        <div class=" program-content flex tenant-main-color justify-end">
          <div>
            <span id="edit" class="ml-8">Edit</span> |
            <span id="delete">Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: ["exercise"],
  methods: {
    ...mapActions([
      "tenantDeleteExercise",
      "fetchTenantAssets",
    ]),
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to delete this exercise?`,
        button: {
          no: "No",
          yes: "Yes",
        },

        callback: (confirm) => {
          if (confirm) {
            this.deleteExercise();

          }
        },
      });
    },
    async deleteExercise() {
      let res = await this.tenantDeleteExercise({
        id: this.exercise.id,
      });

      if (res.status == 200 || res.status == 201) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Exercises deleted succesfully",
        });
        location.reload()
      }
      else{
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
                  ? res.data.errors[0].title
                  : "An error occured",
        });
      }
    },
    navigate(e) {
      e.stopImmediatePropagation();
      if (e.target.id == "edit") {
        this.$router.push({
          name: "tenant-edit-exercise",
          params: { exercise_id: this.exercise.id },
        });
      } else if (e.target.id === "delete") {
        this.handleClick()
        // this.$Bus.$emit("delete-course", this.course.id);
      } else {
        // this.$router.push({
        //   name: "tenant-single-course",
        //   params: { id: this.course.id },
        // });
      }
    },
  },
};
</script>

<style lang="css" scoped>
.program-main {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.program-content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}
</style>
